module.exports = "<div [ngSwitch]=\"projectTypeCode\">\n  <label *ngSwitchCase=\"'WORKSHEET'\" class=\"text-muted\">Worksheet project Name: <span>{{projectName}}</span></label>\n  <label *ngSwitchCase=\"'DELEGATION'\" class=\"text-muted\">Delegation reason: {{delegation.Reason || 'no reason'}}</label>\n  <label *ngSwitchDefault class=\"text-muted\">{{nonExistingProject}}</label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/approvals/project-name/project-name.component.html
// module id = ../../../../../src/app/approvals/project-name/project-name.component.html
// module chunks = main